import { Controller } from "@hotwired/stimulus"

// Generic bitmask ↔ checkboxes converter
// Converts individual checkbox checked states into a single bitmask integer.
//
// Usage:
//   <div data-controller="bitmask-checkboxes">
//     <input type="hidden" data-bitmask-checkboxes-target="field" name="listing[options_bitmask]">
//     <input type="checkbox" data-bitmask-checkboxes-target="checkbox" value="0" data-action="change->bitmask-checkboxes#update">
//     <input type="checkbox" data-bitmask-checkboxes-target="checkbox" value="1" data-action="change->bitmask-checkboxes#update">
//   </div>
export default class extends Controller {
  static targets = ["field", "checkbox"]

  connect() {
    this.syncCheckboxes()
  }

  update() {
    let bitmask = 0
    this.checkboxTargets.forEach(cb => {
      if (cb.checked) bitmask |= (1 << parseInt(cb.value))
    })
    this.fieldTarget.value = bitmask
  }

  // On connect, restore checkbox states from hidden field value
  syncCheckboxes() {
    const bitmask = parseInt(this.fieldTarget.value) || 0
    this.checkboxTargets.forEach(cb => {
      const bit = parseInt(cb.value)
      cb.checked = (bitmask & (1 << bit)) !== 0
    })
  }
}
